<template>
  <div class="c-job-tags">
    <CSeverityTag v-if="job.severity !== null" :severity="job.severity"/>

    <CJobWarrantyBadge :status="job.warrantyStatus"/>

    <CFollowUpAppointmentBadge v-if="job.followUpResolvedOn ?? job.needFollowUp" :resolvedDate="job.followUpResolvedOn"/>

    <CDossierTag v-for="tag in job.tags" :key="tag.id" :tag="tag"/>

    <CTag v-if="job.pauseReason" theme="warning">
      <CIcon name="pause" :size="ICON_SIZE"/>
      {{ job.pauseReason.description }}
    </CTag>

    <template v-if="!hideMetadataCounts">
      <CTag v-if="job.comment" theme="outline" v-tooltip="job.comment.content">
        <CIcon name="bubble" :size="ICON_SIZE"/>
      </CTag>

      <CTag v-if="job.imageCount > 0" theme="outline">
        <CIcon name="image" :size="ICON_SIZE"/>
        {{ job.imageCount }}
      </CTag>

      <CTag v-if="job.videoCount > 0" theme="outline">
        <CIcon name="camera-video" :size="ICON_SIZE"/>
        {{ job.videoCount }}
      </CTag>

      <CTag v-if="job.attachmentCount > 0" theme="outline">
        <CIcon name="attachment-paperclip" :size="ICON_SIZE"/>
        {{ job.attachmentCount }}
      </CTag>

      <CTag v-if="job.diagnosticCount > 0" theme="outline">
        <CIcon name="search-eye" :size="ICON_SIZE"/>
        {{ job.diagnosticCount }}
      </CTag>
    </template>

    <CChecklistStatusTag v-if="job.checklistDetails" :status="job.checklistDetails.status"/>
  </div>
</template>

<script setup lang="ts">
  import CDossierTag from '@/dossier/components/CDossierTag.vue';
  import CFollowUpAppointmentBadge from '@/shared/components/CFollowUpAppointmentBadge.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CTag from '@/shared/components/CTag.vue';
  import Job from '../models/Job';
  import CChecklistStatusTag from './CChecklistStatusTag.vue';
  import CJobWarrantyBadge from './CJobWarrantyBadge.vue';
  import CSeverityTag from './CSeverityTag.vue';

  defineProps<{
    job: Job,
    hideMetadataCounts?: boolean,
  }>();

  const ICON_SIZE = 20;
</script>

<style lang="scss">
  .c-job-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
</style>
